import { createEffect, Effect } from '@beatflyer/shaders-lib';
import { CompositionEffect } from 'compose/CompositionEffect';
import { SignalSource } from 'data/SignalSource';
import { ADDED_FILTER, REMOVE_FILTER } from 'state/actions';
import { getEffectById, getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { filterCache } from 'state/Store';
import { Command, CommandFunction } from './Command';

export class RemoveEffectCommand extends Command {
  effectId: string;
  layerId: string;
  effectSettings: any;
  effectIndex: number;
  effectNameId: string;
  constructor(layerId: string, effectId: string) {
    super();
    this.layerId = layerId;
    this.effectId = effectId;
  }
  execute(firstTime?: boolean | undefined): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const filter = getEffectById(flyer, this.effectId);
      if (layer && filter) {
        if (firstTime) {
          this.effectSettings = filter.toObject();
          this.effectNameId = Object.getPrototypeOf(filter).constructor.id;
          if (!this.effectNameId.startsWith('composition-')) {
            this.effectIndex = layer.effects.indexOf(filter as Effect);
          }
        }
        dispatch({
          type: REMOVE_FILTER,
          layer,
          filter
        });
      }
    };
  }
  undo(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      if (layer) {
        if (this.effectNameId.startsWith('composition-')) {
          const composition = CompositionEffect.createCompositionEffect(
            layer,
            this.effectNameId,
            this.effectSettings
          );
          composition.id = this.effectId;
          layer.compositionEffect?.reset();
          layer.compositionEffect = composition;
          layer.previewedCompositionEffect = null;
        } else {
          const effect = createEffect({
            ...this.effectSettings,
            visible: true,
            name: this.effectNameId
          });
          effect.id = this.effectId;
          effect.layerTransform = layer.sprite.filterTransform;
          effect.cache = filterCache;
          effect.repeat = layer.repeat;
          effect.pixelRatio = flyer.previewPixelRatio.value;
          effect.signalSource = SignalSource.Default;
          if (!layer.effects) {
            layer.effects = [];
          }
          layer.effects.splice(this.effectIndex, 0, effect);
          layer.applyEffects();
          layer.resetGeomTransformation();
          layer.needsUpdate = true;
        }
        dispatch({ type: ADDED_FILTER });
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/RemoveEffectCommand.ts